export const ATTENDANCE_LIST_REQUEST = 'ATTENDANCE_LIST_REQUEST';
export const ATTENDANCE_LIST_SUCCESS = 'ATTENDANCE_LIST_SUCCESS';
export const ATTENDANCE_LIST_FAIL = 'ATTENDANCE_LIST_FAIL';
export const ATTENDANCE_LIST_RESET = 'ATTENDANCE_LIST_RESET';

export const CHECKINOUT_REQUEST = 'CHECKINOUT_REQUEST';
export const CHECKINOUT_SUCCESS = 'CHECKINOUT_SUCCESS';
export const CHECKINOUT_FAIL = 'CHECKINOUT_FAIL';
export const CHECKINOUT_RESET = 'CHECKINOUT_RESET';

export const DELETE_CHECKIN_REQUEST = 'DELETE_CHECKIN_REQUEST';
export const DELETE_CHECKIN_SUCCESS = 'DELETE_CHECKIN_SUCCESS';
export const DELETE_CHECKIN_FAIL = 'DELETE_CHECKIN_FAIL';
export const DELETE_CHECKIN_RESET = 'DELETE_CHECKIN_RESET';

export const GET_TRAINER_SESSIONS_REQUEST = 'GET_TRAINER_SESSIONS_REQUEST';
export const GET_TRAINER_SESSIONS_SUCCESS = 'GET_TRAINER_SESSIONS_SUCCESS';
export const GET_TRAINER_SESSIONS_FAIL = 'GET_TRAINER_SESSIONS_FAIL';
export const GET_TRAINER_SESSIONS_RESET = 'GET_TRAINER_SESSIONS_RESET';

export const ADD_TRAINER_SESSION_REQUEST = 'ADD_TRAINER_SESSION_REQUEST';
export const ADD_TRAINER_SESSION_SUCCESS = 'ADD_TRAINER_SESSION_SUCCESS';
export const ADD_TRAINER_SESSION_FAIL = 'ADD_TRAINER_SESSION_FAIL';
export const ADD_TRAINER_SESSION_RESET = 'ADD_TRAINER_SESSION_RESET';

export const TOTAL_TRAINER_SESSION_REQUEST = 'TOTAL_TRAINER_SESSION_REQUEST';
export const TOTAL_TRAINER_SESSION_SUCCESS = 'TOTAL_TRAINER_SESSION_SUCCESS';
export const TOTAL_TRAINER_SESSION_FAIL = 'TOTAL_TRAINER_SESSION_FAIL';
export const TOTAL_TRAINER_SESSION_RESET = 'TOTAL_TRAINER_SESSION_RESET';
